<template>
    <b-container >
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            :variant="variant">
            {{alertText}}
        </b-alert>

        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row class="justify-content-md-center">
                <b-col md="12" sm="12" class="mt-2">
                    <p style="font-size: 17px;color:#2284ab;">Fees Payment</p>
                    <p></p>
                    <p style="font-size: 0.875rem;">Registration Charges are to be paid by the Guards working with Agency and Principal Employers.</p>
                    <p style="font-size: 0.875rem;">The Board Selected by You is     : <strong>{{board.board}}</strong></p>
                    <p style="font-size: 0.875rem;">The Category Mentioned by you is : <strong>{{board.category}}</strong></p>
                    <p style="font-size: 0.875rem;">Please click 'Next' if the information is correct.</p>
                    <p><b-btn class="mt-2" size="sm" variant="warning" @click="CalculateFees">Next</b-btn></p>

                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;" v-if="showdtls">
                            <span style="font-size: 0.875rem;">Please make online payment, as below, towards registration.
                            </span><br/><br/>
                            <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col md="2" sm="5" style="font-size: 0.875rem;"><strong>Details</strong></b-col>
                              <b-col md="2" sm="5" style="text-align:right;font-size: 0.875rem;"><strong>Amount</strong></b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row>
                            <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col style="font-size: 0.875rem;">Registration Fees</b-col>
                              <b-col style="text-align:right;font-size: 0.875rem;">&#8377; {{fees}}</b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row>
                            <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col style="font-size: 0.875rem;">GST</b-col>
                              <b-col style="text-align:right;font-size: 0.875rem;">&#8377; {{gst}}</b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row>
                            <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col style="font-size: 0.875rem;">Transaction Charges</b-col>
                              <b-col style="text-align:right;font-size: 0.875rem;">&#8377; {{TransactionCharges}}</b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row>
                            <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col style="font-size: 0.875rem;"><strong>Total</strong></b-col>
                              <b-col style="text-align:right;font-size: 0.875rem;"><strong>&#8377; {{total}}</strong></b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row>

                            <span style="font-size: 0.875rem;">Clicking the pay now button will navigate you to a secure payment site. On successful transaction you will be redirected back to the 'Security Guards Board' site. </span>
                            <!-- <p style="font-size: 0.75rem;color:red">*Payment Gateway Charges will be additional and as applicable. </p> -->
                    </div>
                </b-col>
            </b-row>
             <b-row class="mt-2 justify-content-md-center">
                <b-col style="text-align:right">
                <b-button type="submit" small variant="primary">Make Payment</b-button>
                <!-- <b-button type="reset" small variant="danger">Reset</b-button> -->
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import * as _ from "lodash";

export default {
  components: { Spinner },
  data() {
    return {
      msg: "",
      fees: 100.0,
      securityID: "",
      token: "",
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      showdtls:false,
      form: {
        BoardID: "",
        FeesType: "Registration of Existing Guards",
        CategoryTypeID: ""
      },
      total:0,
      gst:0,
      payment: {
        PaymentID: "",
        EventID: "",
        BoardID: "",
        UserID: "",
        TransactionStatus: "Pending",
        TransactionType: "Registration",
        TransactionAmount: 109.0,
        TransactionCharges:4.64,
        Currency: "INR",
        MerchantID: "",
        PaymentStatus: false,
        UserName:"",
        Purpose:"Registration of Existing Security Guards"
      },
    };
  },
  computed: {
    board() {
      var userinfo = this.$store.getters.getUserData;
      //console.log('catid', userinfo.UserReligionCaste.CategoryID);
      this.form.BoardID = userinfo.BoardID;
      this.form.CategoryTypeID = userinfo.UserReligionCaste.CategoryID;
      let listsgb = this.$store.getters.getSGBList;

      let oboardName = _.filter(listsgb, {
        SecurityBoardID: userinfo.BoardID
      });

      let lstcat = this.$store.getters.getCatList;

      let oCType = _.filter(this.$store.getters.getCatList, {
        CategoryID: userinfo.UserReligionCaste.CategoryID
      });
      let rtn={};
      if (oboardName && oCType) {
        rtn =  {
          board: oboardName[0].SecurityBoardName,
          category: oCType[0].CategoryName
        };
      }
      
      return rtn;
    }
  },
  methods: {
    CalculateFees() {

      let promise = apis.getFees(this.form);

      promise
        .then(response => {

          if (response.status == 200) {
            this.fees = response.body.FeesAmount.toFixed(2);
            this.gst = (this.fees * (response.body.TaxRatePercent)/100).toFixed(2);
            this.total = (this.fees * (100+response.body.TaxRatePercent)/100).toFixed(2);
            this.TransactionCharges = (this.total*0.057).toFixed(2);
            this.total = ((this.total*1.00) + (1.0*this.TransactionCharges)).toFixed(2);
            this.isLoading = false;
            this.showdtls = true;
          } else {
            this.alertText = "Error in calculating the Fees amount. Please try again after some time.";

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = "Error in calculating the Fees amount. Please try again after some time.";
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    makePayment() {

      var userinfo = this.$store.getters.loggedUser;
      var token = this.$store.getters.authToken;

      this.payment.UserID = userinfo.UserId;
      this.payment.TransactionAmount = this.total;
      this.payment.UserName = userinfo.UserName;

      let promise = apis.getPmtRequestInstaM(this.payment);

      promise
        .then(response => {
          //console.log('respone1',response);
          if (response.status == 200) {
              
            localStorage.setItem("userinfo", JSON.stringify(userinfo));
            localStorage.setItem("token", token);
 
            window.location = response.body.payment_request.longurl; 
                
              
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.makePayment();
      // var userinfo = this.$store.getters.loggedUser;

      // let CustomerID = "RG" + userinfo.UserId;
      // this.msg =
      //   this.MerchantId +
      //   "|" +
      //   CustomerID +
      //   "|NA|" +
      //   this.fees +
      //   "|NA|NA|NA|INR|NA|R|" +
      //   this.securityID +
      //   "|NA|NA|F|NA|NA|NA|NA|NA|NA|NA|http://sgbregistration.in/paymentconfirm/" +
      //   this.token;
    },
    onReset(evt) {}
  },
  mounted() {
    this.isLoading = true;
    let promiseCat = apis.getCategory();
    promiseCat
      .then(response => {
        //console.log('Reponse' ,response);
        if (response.status == 200) {
          this.categories = response.body;
          this.$store.dispatch("setCatList", response.body);
          this.isLoading = false;
          //this.$router.push("/");
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/FeesPayment.vue